import { render, staticRenderFns } from "./DataTransferHelpDialog.vue?vue&type=template&id=1bb52dc6&scoped=true&"
import script from "./DataTransferHelpDialog.vue?vue&type=script&lang=ts&"
export * from "./DataTransferHelpDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DataTransferHelpDialog.vue?vue&type=style&index=0&id=1bb52dc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb52dc6",
  null
  
)

export default component.exports